import { validateMobile } from "../mobileGroup/Mobile.helpers";

export default function validate(values, event, config) {
    let errors = {};

    const validateField = field => {
        if (field.required) {
            if (!values[field.id]) {
                errors[field.id] = field.requiredMsg ? field.requiredMsg : `${field.displayText} is required`;
            }
        }
        if (values[field.id]) {
            // email validation
            if (field.type === "email") {
                if (!/^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`\{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+-\/=?^_`{|}~a-zA-Z0-9]{0,}){0,})@(([(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,})$/.test(values[field.id]) || values[field.id].split("@").length > 2) {
                    errors[field.id] = "Email address is invalid";
                }
            }

            // eircode validation
            if (field.type === "eircode") {
                if (
                    !/^(?:(a(4[125]|6[37]|75|8[1-6]|9[12468])|c15|d(0[1-9]|1[0-8]|2[024]|6w)|e(2[15]|3[24]|4[15]|53|91)|f(12|2[368]|3[15]|4[25]|5[26]|9[1-4])|h(1[2468]|23|5[34]|6[25]|[79]1)|k(3[246]|45|56|67|78)|n(3[79]|[49]1)|p(1[247]|2[45]|3[126]|4[37]|5[16]|6[17]|7[25]|8[15])|r(14|21|3[25]|4[25]|5[16]|9[35])|t(12|23|34|45|56)|v(1[45]|23|3[15]|42|9[2-5])|w(12|23|34|91)|x(35|42|91)|y(14|2[15]|3[45]))\s?[abcdefhknoprtsvwxy\d]{4})$/i.test(
                        values[field.id]
                    )
                ) {
                    errors[field.id] = "Eircode is invalid";
                }
            }

            // first name / last name validation
            if (field.nameValidation) {
                if (!/^([a-zÀ-ž\u00C0-\u02AB-\u0370-\u03FF\u0400-\u04FF´`-‘’']\.?\s?)+$/i.test(values[field.id])) {
                    errors[field.id] = "Please only use letters, hyphens or apostrophes";
                }
            }

            if (field.nameOrAddressValidation) {
                if (!/^([a-zÀ-ž0-9\u00C0-\u02AB-\u0370-\u03FF\u0400-\u04FF´`-‘’',]\.?\s?)+$/i.test(values[field.id])) {
                    errors[field.id] = "Please only use letters, numbers, hyphens or apostrophes";
                }
            }

            // regex validation
            if (field.regularExpression) {
                if (!field.regularExpression.test(values[field.id])) {
                    errors[field.id] = field.regExWarn ? field.regExWarn : "You have entered an incorrect format";
                }
            }

            if (field.reservedWords) {
                field.reservedWords.forEach(word => {
                    if (values[field.id].replace(/\s+$/, "").toUpperCase() === word.toUpperCase() && !values[`${field.id}Disabled`]) {
                        errors[field.id] = "To add your home or business address go to the profile & settings page"
                    }
                });
            }

            // min length validation
            if (field.minLength) {
                if (values[field.id].length < field.minLength) {
                    errors[field.id] = `This field must be a minimum of ${field.minLength} characters`;
                }
            }

            // max length validation
            if (field.maxLength) {
                if (values[field.id].length > Number(field.maxLength)) {
                    errors[field.id] = `This field an only be a maximum of ${field.maxLength} characters`;
                }
            }
        }
    };

    config.fields.forEach(field => {
        // validate the field
        validateField(field);

        // if there is a pair of fields loop through the pair and validate the fields
        if (field.formType === "duoField") {
            field.fields.forEach(innerField => {
                validateField(innerField);
            });
        }
        // if it is an address
        if (field.formType === "address") {
            // if it's international
            if (values[`${field.id}NatOrInternational`] === "international") {
                if (!values[`${field.id}Addresslineone`]) {
                    errors[`${field.id}Addresslineone`] = "Address Line one is required";
                }
                if (!values[`${field.id}Addresslinetwo`]) {
                    errors[`${field.id}Addresslinetwo`] = "Address Line two is required";
                }
                if (!values[`${field.id}intCountry`] || values[`${field.id}intCountry`] === "Ireland") {
                    errors[`${field.id}intCountry`] = "Country is a required field";
                }
                if (!values[`${field.id}City`]) {
                    errors[`${field.id}City`] = "City is a required field";
                }
                if (!/^([a-zÀ-ž\u00C0-\u02AB-\u0370-\u03FF\u0400-\u04FF´`-‘’']\.?\s?)+$/i.test(values[`${field.id}City`])) {
                    errors[`${field.id}City`] = "Please enter a valid state or city";
                }
            } else if (values[`${field.id}Manual`]) {
                if (!values[`${field.id}Addresslineone`]) {
                    errors[`${field.id}Addresslineone`] = "Address Line one is required";
                }

                if (values[`${field.id}Eircode`]) {
                    if (
                        !/^(?:(a(4[125]|6[37]|75|8[1-6]|9[12468])|c15|d(0[1-9]|1[0-8]|2[024]|6w)|e(2[15]|3[24]|4[15]|53|91)|f(12|2[368]|3[15]|4[25]|5[26]|9[1-4])|h(1[2468]|23|5[34]|6[25]|[79]1)|k(3[246]|45|56|67|78)|n(3[79]|[49]1)|p(1[247]|2[45]|3[126]|4[37]|5[16]|6[17]|7[25]|8[15])|r(14|21|3[25]|4[25]|5[16]|9[35])|t(12|23|34|45|56)|v(1[45]|23|3[15]|42|9[2-5])|w(12|23|34|91)|x(35|42|91)|y(14|2[15]|3[45]))\s?[abcdefhknoprtsvwxy\d]{4})$/i.test(
                            values[`${field.id}Eircode`]
                        )
                    ) {
                        errors[`${field.id}Eircode`] = "Eircode is invalid.";
                    }
                }

                if (!values[`${field.id}Town`]) {
                    errors[`${field.id}Town`] = "Town is a required field";
                }

                if (values[`${field.id}Town`]) {
                    if (values[`${field.id}Town`].length < 3) {
                        errors[`${field.id}Town`] = "Town should be a minimum of 3 characters long.";
                    }
                }

                if (!values[`${field.id}County`]) {
                    errors[`${field.id}County`] = "County is a required field";
                }
            } else {
                if (!values[`${field.id}`]) {
                    errors[`${field.id}`] = "Please supply an address";
                }
                if (!values[`${field.id}Valid`]) {
                    errors[`${field.id}`] = "Please supply a valid address";
                }
            }
        }

        if (field.formType === "mobile") {
            errors = validateMobile(values, errors, field.id, !!field.optional);
        }
    });
    return errors;
}
